import { render, staticRenderFns } from "./IdeasEdit.vue?vue&type=template&id=055e5f76&"
import script from "./IdeasEdit.vue?vue&type=script&lang=js&"
export * from "./IdeasEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports